import { Component } from '@theme/component';
import { debounce, fetchConfig } from '@theme/utilities';
import { cartPerformance } from '@theme/performance';

/** The cart attribute key this field is saved under. Must match the `name="attributes[...]"` on the input. */
const FUNDRAISER_CODE_ATTRIBUTE = 'School or Organization Code';

/**
 * A custom element that saves an optional fundraiser/school code as a cart attribute.
 */
class CartFundraiserCode extends Component {
  /** @type {AbortController | null} */
  #activeFetch = null;

  /**
   * Handles updates to the fundraiser code field.
   * @param {InputEvent} event - The input event in our text field.
   */
  updateFundraiserCode = debounce(async (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;

    const code = event.target.value.trim();
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;

    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ attributes: { [FUNDRAISER_CODE_ATTRIBUTE]: code } }),
      });

      await fetch(Theme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });
    } catch (error) {
    } finally {
      this.#activeFetch = null;
      cartPerformance.measureFromEvent('fundraiser-code-update:user-action', event);
    }
  }, 200);
}

if (!customElements.get('cart-fundraiser-code')) {
  customElements.define('cart-fundraiser-code', CartFundraiserCode);
}
